import {
  PRODUCTS_AND_SERVICES_DOMESTIC,
  PRODUCTS_AND_SERVICES_INTERNATIONAL,
  PROHIBITED_LIST,
} from '../components/DpdAppBar/constants';

export const EXTERNAL_NAV_ITEMS = [
  'send',
  'track',
  'return',
  'pickupFinder',
  'business',
];

export const PRODUCTS_AND_SERVICES_ITEM = {
  id: 'products-and-services',
  label: 'Products & Services',
  expandable: true,
  children: [
    {
      label: 'Domestic',
      expandable: true,
      children: PRODUCTS_AND_SERVICES_DOMESTIC.map(({ title, route }) => ({
        label: title,
        path: route,
      })),
    },
    {
      label: 'International',
      expandable: true,
      children: PRODUCTS_AND_SERVICES_INTERNATIONAL.map(({ title, route }) => ({
        label: title,
        path: route,
      })),
    },
    { label: PROHIBITED_LIST.title, path: PROHIBITED_LIST.route },
  ],
};

export const SECONDARY_NAV_BY_PRIMARY = {
  send: [
    { id: 'quick-quote', label: 'Quick Quote', path: '/' },
    {
      id: 'send-a-parcel',
      label: 'Send a Parcel',
      path: '/quotes',
      matchPaths: ['/quotes', '/order', '/basket'],
    },
    {
      id: 'send-a-citysprint-parcel',
      label: 'Send a Same Day Parcel',
      path: '/send-citysprint-parcel',
      matchPaths: [
        '/send-citysprint-parcel',
        '/send-citysprint-parcel/summary',
        '/send-citysprint-parcel/complete-booking',
        '/send-citysprint-parcel/review-book',
        '/citysprint',
      ],
    },
    PRODUCTS_AND_SERVICES_ITEM,
    { id: 'help', label: 'Help', path: '/help' },
    { id: 'faq', label: 'FAQs', path: '/FAQ' },
  ],
  track: [{ id: 'track-dpd-online', label: 'DPD Online', path: '/track' }],
  return: [{ id: 'return', label: 'Return', path: '/return' }],
  pickupFinder: [
    { id: 'pickup-finder', label: 'Pickup Finder', path: '/pickup-finder' },
  ],
  businessAccount: [
    {
      id: 'business',
      label: 'Business Account',
      path: '/business',
    },
  ],
};
